import React, { useState, useEffect } from 'react';
import { VOTER_ORANGE, voterIcons } from '../component/voterCardIcons';
import axios from 'axios';
import { useAppId } from '../context/AppIdContext';
import { useLocation, useNavigate } from 'react-router-dom';
import '../style/speakSearch.css';
import Header from '../component/header';
import WhatsappSlipButton from '../component/WhatsappSlipButton';
import PracharButton from '../component/PracharButton'; 

const BASE_URL = process.env.REACT_APP_BASE_URL;

const MyGroup = () => {
    // --- State ---
    const [members, setMembers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [cardSearchTerm, setCardSearchTerm] = useState("");

    // --- Bulk Send Popup State ---
    const [isBulkSendPopupOpen, setIsBulkSendPopupOpen] = useState(false);

    // --- NEW: Remove Button Visibility State ---
    const [isRemoveShow, setIsRemoveShow] = useState("1"); // 1 હોય તો બતાવશે, 0 હોય તો નહિ બતાવે

    // --- Context ---
    const { appId, language, userId, whtspApi, wtspDeviceId } = useAppId();
    const lang = language || 'en';

    const location = useLocation();
    const navigate = useNavigate();

    const user_name = location.state?.userName;

    // --- Translation Dictionary ---
    const t = {
        en: {
            pageTitle: (user_name ? user_name : "My") + " Group",
            pageSubtitle: "List of members assigned to your personal group.",
            filterPlaceholder: "Filter group members by name...",
            loadingData: "Loading Data...",
            noMembers: "No members found in your group.",
            noMatching: "No matching names found.",
            fatherHusband: "F/S :",
            serialNo: "Sr No. :",
            mobile: "Mobile :",
            idCardNo: "ID Card No :",
            boothNo: "Booth No :",
            houseNo: "House No :",
            pollingLoc: "Voting Loc :",
            call: "Call",
            text: "Text",
            slip: "Slip",
            prachar: "Prachar",
            print: "Print",
            family: "Family",
            foundLabel: "members found",
            removeFromGroup: "Remove",
            address: "Address :",
            editMobileTitle: "Update Mobile Number",
            mobilePlaceholder: "Enter 10-digit mobile number",
            mobileErrorLength: "Mobile number must be 10 digits",
            mobileErrorStart: "Number must start with 6, 7, 8, or 9",
            cancel: "Cancel",
            save: "Save",
            saving: "Saving...",
            mobileUpdateSuccess: "Mobile number updated successfully!",
            mobileUpdateFailed: "Failed to update mobile number.",
            mobileUpdateError: "An error occurred while updating the mobile number.",
            mobileNotAvailable: "Mobile number is not available for this voter.",
            addressNotAvailable: "Address not available!",
            removeConfirm: "Are you sure you want to remove this member from your group?",
            removeSuccess: "Removed from group successfully!",
            removeFailed: "Failed to remove from group.",
            removeError: "An error occurred while removing from the group.",
            familyFetchError: "Could not fetch family details.",
            messageError: "Error generating message.",
            smsFamilyError: "Could not fetch family details for SMS.",
            smsMessageError: "Error generating SMS message.",
            mobileNotAvailableAlert: "Mobile number is not available for this voter.",
            bulkSend: "Bulk Send",
            bulkSendTitle: "Bulk Send Options",
            sendToAll: "Send to All",
            sendToRemaining: "Send to Remaining",
            addMember: "Add Member"
        },
        hi: {
            pageTitle: "मेरा समूह",
            pageSubtitle: "आपके व्यक्तिगत समूह में शामिल सदस्यों की सूची।",
            filterPlaceholder: "नाम से प्रदर्शित परिणाम फ़िल्टर करें...",
            loadingData: "डेटा लोड हो रहा है...",
            noMembers: "आपके समूह में कोई सदस्य नहीं मिला।",
            noMatching: "मेल खाने वाले कोई नाम नहीं मिले।",
            fatherHusband: "पिता/पति :",
            serialNo: "क्रमांक :",
            mobile: "मोबाइल :",
            idCardNo: "पहचान पत्र नं.:",
            boothNo: "बूथ नं :",
            houseNo: "घर नं :",
            pollingLoc: "मतदान स्थान :",
            call: "कॉल",
            text: "मैसेज",
            slip: "पर्ची",
            prachar: "प्रचार",
            print: "प्रिंट",
            family: "परिवार",
            foundLabel: "सदस्य मिले",
            removeFromGroup: "हटाएं",
            address: "पता :",
            editMobileTitle: "मोबाइल नंबर अपडेट करें",
            mobilePlaceholder: "10 अंकों का मोबाइल नंबर दर्ज करें",
            mobileErrorLength: "मोबाइल नंबर 10 अंकों का होना चाहिए",
            mobileErrorStart: "नंबर 6, 7, 8, या 9 से शुरू होना चाहिए",
            cancel: "रद्द करें",
            save: "सेव करें",
            saving: "सेव हो रहा है...",
            mobileUpdateSuccess: "मोबाइल नंबर सफलतापूर्वक अपडेट हो गया!",
            mobileUpdateFailed: "मोबाइल नंबर अपडेट करने में विफल।",
            mobileUpdateError: "मोबाइल नंबर अपडेट करते समय एक त्रुटि हुई।",
            mobileNotAvailable: "इस मतदाता के लिए मोबाइल नंबर उपलब्ध नहीं है।",
            addressNotAvailable: "पता उपलब्ध नहीं है!",
            removeConfirm: "क्या आप वाकई इस सदस्य को अपने समूह से हटाना चाहते हैं?",
            removeSuccess: "समूह से सफलतापूर्वक हटा दिया गया!",
            removeFailed: "समूह से हटाने में विफल।",
            removeError: "समूह से हटाते समय एक त्रुटि हुई।",
            familyFetchError: "परिवार का विवरण प्राप्त नहीं किया जा सका।",
            messageError: "संदेश उत्पन्न करने में त्रुटि।",
            smsFamilyError: "एसएमएस के लिए परिवार का विवरण प्राप्त नहीं किया जा सका।",
            smsMessageError: "एसएमएस संदेश उत्पन्न करने में त्रुटि।",
            mobileNotAvailableAlert: "इस मतदाता के लिए मोबाइल नंबर उपलब्ध नहीं है।",
            bulkSend: "बल्क भेजें",
            bulkSendTitle: "बल्क सेंड विकल्प",
            sendToAll: "सभी को भेजें",
            sendToRemaining: "बाकी को भेजें",
            addMember: "सदस्य जोड़ें"
        },
        gu: {
            pageTitle: "મારું જૂથ",
            pageSubtitle: "તમારા વ્યક્તિગત જૂથમાં સોંપાયેલ સભ્યોની યાદી.",
            filterPlaceholder: "જૂથના સભ્યોને નામથી ફિલ્ટર કરો...",
            loadingData: "ડેટા લોડ થઈ રહ્યો છે...",
            noMembers: "તમારા જૂથમાં કોઈ સભ્ય મળ્યા નથી.",
            noMatching: "કોઈ મેળ ખાતું નામ મળ્યું નથી.",
            fatherHusband: "પિતા/પતિ :",
            serialNo: "ક્રમાંક :",
            mobile: "મોબાઇલ :",
            idCardNo: "ઓળખ કાર્ડ નં :",
            boothNo: "બૂથ નં :",
            houseNo: "ઘર નં :",
            pollingLoc: "મતદાન સ્થળ :",
            call: "કૉલ",
            text: "સંદેશ",
            slip: "સ્લિપ",
            prachar: "પ્રચાર",
            print: "પ્રિન્ટ",
            family: "કુટુંબ",
            foundLabel: "સભ્યો મળ્યા",
            removeFromGroup: "દૂર કરો",
            address: "સરનામું :",
            editMobileTitle: "મોબાઇલ નંબર અપડેટ કરો",
            mobilePlaceholder: "10 અંકોનો મોબાઇલ નંબર દાખલ કરો",
            mobileErrorLength: "મોબાઇલ નંબર 10 અંકોનો હોવો જોઈએ",
            mobileErrorStart: "નંબર 6, 7, 8, અથવા 9 થી શરૂ થવો જોઈએ",
            cancel: "રદ કરો",
            save: "સેવ કરો",
            saving: "સેવ થઈ રહ્યું છે...",
            mobileUpdateSuccess: "મોબાઇલ નંબર સફળતાપૂર્વક અપડેટ થયો!",
            mobileUpdateFailed: "મોબાઇલ નંબર અપડેટ કરવામાં નિષ્ફળ.",
            mobileUpdateError: "મોબાઇલ નંબર અપડેટ કરતી વખતે એક ભૂલ આવી.",
            mobileNotAvailable: "આ મતદાર માટે મોબાઇલ નંબર ઉપલબ્ધ નથી.",
            addressNotAvailable: "સરનામું ઉપલબ્ધ નથી!",
            removeConfirm: "શું તમે ખરેખર આ સભ્યને તમારા જૂથમાંથી દૂર કરવા માંગો છો?",
            removeSuccess: "જૂથમાંથી સફળતાપૂર્વક દૂર કરવામાં આવ્યું!",
            removeFailed: "જૂથમાંથી દૂર કરવામાં નિષ્ફળ.",
            removeError: "જૂથમાંથી દૂર કરતી વખતે એક ભૂલ આવી.",
            familyFetchError: "કુટુંબની વિગતો મેળવી શકાઈ નહીં.",
            messageError: "સંદેશ બનાવવામાં ભૂલ.",
            smsFamilyError: "એસએમએસ માટે કુટુંબની વિગતો મેળવી શકાઈ નહીં.",
            smsMessageError: "એસએમએસ સંદેશ બનાવવામાં ભૂલ.",
            mobileNotAvailableAlert: "આ મતદાર માટે મોબાઇલ નંબર ઉપલબ્ધ નથી.",
            bulkSend: "બલ્ક મોકલો",
            bulkSendTitle: "બલ્ક સેન્ડ વિકલ્પો",
            sendToAll: "બધાને મોકલો",
            sendToRemaining: "બાકીનાને મોકલો",
            addMember: "સભ્ય ઉમેરો"
        }
    };

    const txt = t[lang];

    // --- Edit Mobile State ---
    const [isEditMobileOpen, setIsEditMobileOpen] = useState(false);
    const [editingVoter, setEditingVoter] = useState(null);
    const [newMobile, setNewMobile] = useState('');
    const [isSavingMobile, setIsSavingMobile] = useState(false);

    // --- Edit Mobile API Call ---
    const handleUpdateMobile = async () => {
        if (!newMobile || newMobile.length !== 10) {
            alert(txt.mobileErrorLength);
            return;
        }

        setIsSavingMobile(true);
        try {
            const payload = {
                app_id: appId?.toString(),
                voter_id: editingVoter.idcard_no,
                mobile_no: newMobile,
                modify_by: userId?.toString() || "1"
            };

            const response = await axios.post(`${BASE_URL}/api/upd_voter_mobile`, payload);

            if (response.data.success || response.data.Success === "1") {
                alert(txt.mobileUpdateSuccess);
                setMembers(prev => prev.map(v =>
                    v.id === editingVoter.id ? { ...v, contact_no: newMobile } : v
                ));
                setIsEditMobileOpen(false);
            } else {
                alert(txt.mobileUpdateFailed);
            }
        } catch (error) {
            console.error("Error updating mobile:", error);
            alert(txt.mobileUpdateError);
        } finally {
            setIsSavingMobile(false);
        }
    };

    // Retrieve userId passed from the previous page
    const passedUserId = location.state?.userId;
    const targetUserId = passedUserId || userId;

    // --- API Fetch Function ---
    const fetchGroupMembers = async () => {
        if (!appId || !userId) return;
        setLoading(true);
        setCardSearchTerm("");

        try {
            const response = await axios.post(
                `${BASE_URL}/api/dis_my_group_member`,
                {
                    app_id: appId,
                    user_id: targetUserId
                }
            );

            if (response.data.success && Array.isArray(response.data.data.result)) {
                setMembers(response.data.data.result);
            } else {
                setMembers([]);
            }
        } catch (error) {
            console.error("Error fetching group members:", error);
            setMembers([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!appId) {
            navigate("/");
            return;
        }
        fetchGroupMembers();
    }, [appId, userId]);

    // --- Filter Logic ---
    const filteredMembers = members.filter((member) => {
        if (!cardSearchTerm) return true;
        const searchTerm = cardSearchTerm.toLowerCase().trim();
        const fName = member.eng_f_name ? member.eng_f_name.toLowerCase() : "";
        const mName = member.eng_m_name ? member.eng_m_name.toLowerCase() : "";
        const sName = member.eng_surname ? member.eng_surname.toLowerCase() : "";
        const fullName = `${fName} ${mName} ${sName}`.replace(/\s+/g, ' ').trim();
        const shortName = `${fName} ${sName}`.replace(/\s+/g, ' ').trim();
        const mobile = member.contact_no ? String(member.contact_no).toLowerCase() : "";

        return fullName.includes(searchTerm) || shortName.includes(searchTerm) || mobile.includes(searchTerm);
    });

    // --- Remove from Group API Call ---
    const handleRemoveFromGroup = async (member) => {
        if (window.confirm(txt.removeConfirm)) {
            try {
                const payload = {
                    id: member.member_id
                };
                console.log(member);
                const response = await axios.post(`${BASE_URL}/api/del_my_group_member`, payload);

                if (response.data.success) {
                    alert(txt.removeSuccess);
                    fetchGroupMembers(); // Re-fetch list to update UI
                } else {
                    alert(txt.removeFailed);
                }
            } catch (error) {
                console.error("Error removing from group:", error);
                alert(txt.removeError);
            }
        }
    };

    // --- WhatsApp Message Generation Logic ---
    const handleWhatsAppShare = async (voter) => {
        if (!voter.contact_no) {
            alert(txt.mobileNotAvailable);
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_wtsp`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('स्री', 'स्त्री')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');
                if (mobile.length === 10) mobile = '91' + mobile;

                window.open(`https://wa.me/${mobile}?text=${encodedMessage}`, '_blank');

            } else {
                alert(txt.familyFetchError);
            }
        } catch (error) {
            console.error("Error generating WhatsApp slip:", error);
            alert(txt.messageError);
        }
    };

    // --- SMS Message Generation Logic ---
    const handleSmsShare = async (voter) => {
        if (!voter.contact_no) {
            alert(txt.mobileNotAvailable);
            return;
        }

        try {
            const response = await axios.post(`${BASE_URL}/api/get_receipt_in_all_family_for_sms`, {
                app_id: appId,
                voter_id: voter.id,
                user_id: userId
            });

            if (response.data.success && response.data.data && response.data.data.result) {
                const familyMembers = response.data.data.result;
                let message = "";

                familyMembers.forEach((member, index) => {
                    message += `${member.first_detail.replace(/\s+/g, ' ')}\n`;
                    message += `${member.full_name}\n`;
                    message += `${member.middle_name}\n`;
                    message += `${member.sex_age.replace('स्री', 'स्त्री')}\n`;
                    message += `${member.idcard_no}\n`;
                    message += `મતદાન સ્થળ : ${member.eng_polling_location}\n`;
                    message += `મતદાન તા. : ૨૬-૦૪-૨૦૨૬, રવિવાર \n સમય : સવારે ૭.૦૦ થી સાંજે ૬.૦૦ સુધી\n\n`;

                    if (index < familyMembers.length - 1) {
                        message += `----------------------------------------\n\n`;
                    }
                });

                const encodedMessage = encodeURIComponent(message);
                let mobile = voter.contact_no.replace(/\D/g, '');

                // Open native SMS app with pre-filled body
                window.location.href = `sms:${mobile}?body=${encodedMessage}`;

            } else {
                alert(txt.smsFamilyError);
            }
        } catch (error) {
            console.error("Error generating SMS slip:", error);
            alert(txt.smsMessageError);
        }
    };

    return (
        <div className='app-container p-4'>

            <Header
                title={txt.pageTitle}
            />

            {/* Mobile Number Edit Modal */}
            {isEditMobileOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }} onClick={() => setIsEditMobileOpen(false)}>
                    <div className="slide-up-element" style={{ background: 'white', padding: '24px', borderRadius: '16px', width: '90%', maxWidth: '350px', boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)' }} onClick={(e) => e.stopPropagation()}>
                        <h4 style={{ margin: '0 0 16px 0', fontSize: '18px', color: '#0f172a', fontWeight: '700' }}>{txt.editMobileTitle}</h4>
                        <p style={{ margin: '0 0 12px 0', fontSize: '13px', color: '#64748b' }}>{editingVoter?.eng_f_name} {editingVoter?.eng_surname}</p>

                        <div style={{ marginBottom: '24px' }}>
                            <input
                                type="tel"
                                maxLength="10"
                                value={newMobile}
                                onChange={(e) => setNewMobile(e.target.value.replace(/[^0-9]/g, ''))}
                                style={{
                                    width: '100%',
                                    padding: '12px 16px',
                                    border: (newMobile && !/^[6-9]\d{9}$/.test(newMobile) && newMobile.length === 10) ? '1px solid #ef4444' : '1px solid #cbd5e1',
                                    borderRadius: '10px',
                                    fontSize: '15px',
                                    outline: 'none',
                                    boxSizing: 'border-box'
                                }}
                                placeholder={txt.mobilePlaceholder}
                                autoFocus
                            />
                            {newMobile && newMobile.length > 0 && !/^[6-9]\d{9}$/.test(newMobile) && (
                                <div style={{ fontSize: '11px', color: '#ef4444', marginTop: '6px', fontWeight: '500' }}>
                                    {newMobile.length < 10 ? txt.mobileErrorLength : txt.mobileErrorStart}
                                </div>
                            )}
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                            <button
                                onClick={() => setIsEditMobileOpen(false)}
                                style={{ padding: '10px 16px', background: 'white', color: '#475569', border: '1px solid #cbd5e1', borderRadius: '10px', cursor: 'pointer', fontWeight: '600' }}
                            >
                                {txt.cancel}
                            </button>
                            <button
                                onClick={handleUpdateMobile}
                                disabled={isSavingMobile || !/^[6-9]\d{9}$/.test(newMobile)}
                                style={{
                                    padding: '10px 20px',
                                    background: (!/^[6-9]\d{9}$/.test(newMobile)) ? '#94a3b8' : '#2563eb',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '10px',
                                    cursor: (!/^[6-9]\d{9}$/.test(newMobile)) ? 'not-allowed' : 'pointer',
                                    fontWeight: '600'
                                }}
                            >
                                {isSavingMobile ? txt.saving : txt.save}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* --- UPDATED: Bulk Send Option Modal with Increased Size and Cross Icon --- */}
            {isBulkSendPopupOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(15, 23, 42, 0.6)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }} onClick={() => setIsBulkSendPopupOpen(false)}>
                    <div className="slide-up-element" style={{ background: 'white', padding: '32px', borderRadius: '20px', width: '90%', maxWidth: '420px', position: 'relative', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)' }} onClick={(e) => e.stopPropagation()}>

                        {/* Cross Icon for Closing */}
                        <button
                            onClick={() => setIsBulkSendPopupOpen(false)}
                            style={{
                                position: 'absolute',
                                top: '16px',
                                right: '16px',
                                background: 'transparent',
                                border: 'none',
                                cursor: 'pointer',
                                color: '#94a3b8',
                                padding: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                transition: 'background 0.2s'
                            }}
                            onMouseOver={(e) => e.currentTarget.style.background = '#f1f5f9'}
                            onMouseOut={(e) => e.currentTarget.style.background = 'transparent'}
                        >
                            <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>

                        <h4 style={{ margin: '0 0 24px 0', fontSize: '20px', color: '#0f172a', fontWeight: '800', textAlign: 'center' }}>{txt.bulkSendTitle}</h4>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            <button
                                onClick={() => {
                                    setIsBulkSendPopupOpen(false);
                                    navigate('/wtsp_bulk_slip_send', { state: { voters: filteredMembers, type: 'all' } });
                                }}
                                style={{ padding: '14px 20px', background: '#2563eb', color: 'white', border: 'none', borderRadius: '12px', cursor: 'pointer', fontWeight: '600', fontSize: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', transition: 'transform 0.2s' }}
                                onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                            >
                                <span>{txt.sendToAll}</span>
                                <span style={{ background: 'rgba(255,255,255,0.2)', padding: '4px 10px', borderRadius: '12px' }}>{filteredMembers.length}</span>
                            </button>
                            <button
                                onClick={() => {
                                    setIsBulkSendPopupOpen(false);
                                    const remainingVoters = filteredMembers.filter(v => v.slip_send == 0 || !v.slip_send);
                                    navigate('/wtsp_bulk_slip_send', { state: { voters: remainingVoters, type: 'remaining' } });
                                }}
                                style={{ padding: '14px 20px', background: '#f59e0b', color: 'white', border: 'none', borderRadius: '12px', cursor: 'pointer', fontWeight: '600', fontSize: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', transition: 'transform 0.2s' }}
                                onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                            >
                                <span>{txt.sendToRemaining}</span>
                                <span style={{ background: 'rgba(255,255,255,0.3)', padding: '4px 10px', borderRadius: '12px', color: '#fff' }}>{filteredMembers.filter(v => v.slip_send == 0 || !v.slip_send).length}</span>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Professional Filter Container (Always Visible) */}
            <div className="filter-container-modern" style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center' }}>
                <div className="search-wrapper-modern">
                    <svg className="search-icon-modern" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                    <input
                        className="search-input-modern"
                        type="text"
                        placeholder={txt.filterPlaceholder}
                        value={cardSearchTerm}
                        onChange={(e) => setCardSearchTerm(e.target.value)}
                    />
                </div>

                <div className="action-group-modern" style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', alignItems: 'center' }}>
                    {/* --- Count Display --- */}
                    {!loading && (
                        <div className="count-display-modern slide-up-element">
                            <span className="count-label">Total :</span>
                            <span className="count-number">{filteredMembers.length}</span>
                        </div>
                    )}

                    <button
                        className="btn-add-member slide-up-element"
                        onClick={() => navigate('/master_search')}
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
                            <line x1="12" y1="5" x2="12" y2="19"></line>
                            <line x1="5" y1="12" x2="19" y2="12"></line>
                        </svg>
                        {txt.addMember}
                    </button>

                    {/* --- Bulk Send Opens Popup --- */}
                    {Number(whtspApi) === 1 && wtspDeviceId && (
                        <button
                            className="btn-bulk-send slide-up-element"
                            onClick={() => setIsBulkSendPopupOpen(true)}
                        >
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
                                <line x1="22" y1="2" x2="11" y2="13"></line>
                                <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                            </svg>
                            {txt.bulkSend}
                        </button>
                    )}
                </div>
            </div>

            {loading && (
                <div className="loader-wrapper">
                    <div className="spinner"></div>
                    <p className="loader-text">{txt.loadingData}</p>
                </div>
            )}

            {!loading && filteredMembers.length === 0 && (
                <div className="text-center text-muted p-5">
                    {members.length === 0 ? txt.noMembers : txt.noMatching}
                </div>
            )}

            {/* --- GRID SYSTEM --- */}
            <div className="row g-4">
                {!loading && filteredMembers.map((member, index) => (
                    <div className="col-12 col-md-6 col-lg-4" key={member.id || index}>
                        <div className="voter-card-clean h-100">
                            <div className="voter-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div>
                                    <span className="serial-number">{index + 1}.</span>
                                    <span className="voter-name-bold ms-2">
                                        {member.eng_f_name || ""} {member.eng_surname || ""}
                                    </span>
                                </div>

                                {/* ✅ REMOVE BUTTON VISIBILITY LOGIC ADDED HERE */}
                                {String(isRemoveShow) === "1" && (
                                    <button
                                        onClick={() => handleRemoveFromGroup(member)}
                                        style={{
                                            backgroundColor: '#fef2f2',
                                            color: '#ef4444',
                                            border: '1px solid #fecaca',
                                            borderRadius: '20px',
                                            padding: '4px 10px',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease'
                                        }}
                                        onMouseOver={(e) => { e.target.style.backgroundColor = '#fee2e2'; }}
                                        onMouseOut={(e) => { e.target.style.backgroundColor = '#fef2f2'; }}
                                    >
                                        - {txt.removeFromGroup}
                                    </button>
                                )}
                            </div>

                            <div className="voter-body position-relative">
                                <div className="info-row"><span className="label">{txt.fatherHusband}</span><span className="value">{member.eng_m_name || "N/A"}</span></div>
                                <div className="info-row"><span className="label">{txt.address}</span><span className="value">{member.eng_localityid || "N/A"}</span></div>
                                <div className="info-row"><span className="label">{txt.serialNo}</span><span className="value">{member.slnoinpart}</span></div>
                                <div className="info-row" style={{ display: 'flex', alignItems: 'center' }}>
                                    <span className="label">{txt.mobile}</span>
                                    <span className="value mobile-value" style={{ flexGrow: 1 }}>{member.contact_no || "N/A"}</span>
                                    <svg
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setEditingVoter(member);
                                            setNewMobile(member.contact_no || '');
                                            setIsEditMobileOpen(true);
                                        }}
                                        style={{ cursor: 'pointer', color: '#f59e0b', width: '18px', height: '18px', flexShrink: 0 }}
                                        fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                                    </svg>
                                </div>
                                <div className="info-row"><span className="label">{txt.idCardNo}</span><span className="value">{member.idcard_no || "N/A"}</span></div>
                                <div className="info-row"><span className="label">{txt.boothNo}</span><span className="value">{member.part_no || "N/A"}</span></div>
                                <div className="info-row"><span className="label">{txt.houseNo}</span><span className="value">{member.eng_house_no || "N/A"}</span></div>
                                <div className="info-row"><span className="label">{txt.pollingLoc}</span><span className="value">{member.eng_polling_location || "-"}</span></div>
                            </div>

                            <div className="voter-actions">
                                <ActionButton icon={voterIcons.call} color={VOTER_ORANGE} label={txt.call}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (!member.contact_no || member.contact_no === "N/A" || member.contact_no === "-" || member.contact_no === "") {
                                            alert(txt.mobileNotAvailableAlert);
                                        }
                                        else {
                                            window.open(`tel:${member.contact_no}`, '_blank');
                                        }
                                    }}
                                />
                                <ActionButton icon={voterIcons.text} color={VOTER_ORANGE} label={txt.text} onClick={() => handleSmsShare(member)} />
                                <WhatsappSlipButton voter={member} />
                                <PracharButton voter={member} />
                                <ActionButton
                                    icon={voterIcons.print} color={VOTER_ORANGE}
                                    label={txt.print}
                                    onClick={() => navigate('/printer', { state: { voter_id: member.id } })}
                                />
                                <ActionButton icon={voterIcons.family} color={VOTER_ORANGE} label={txt.family} onClick={() => navigate('/dis_family_member', { state: { voter_id: member.id } })} />
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <style jsx>{`
                /* --- PROFESSIONAL FILTER BAR --- */
                .filter-container-modern {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    margin-bottom: 24px;
                }
                .search-wrapper-modern {
                    position: relative;
                    width: 100%;
                    flex: 1;
                    max-width: 450px;
                }
                .search-icon-modern {
                    position: absolute;
                    left: 16px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #94a3b8;
                    width: 18px;
                    height: 18px;
                }
                .search-input-modern {
                    width: 100%;
                    padding: 12px 16px 12px 46px;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    font-size: 14px;
                    color: #1e293b;
                    outline: none;
                    transition: all 0.2s ease;
                    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
                }
                .search-input-modern:focus {
                    border-color: #2563eb;
                    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
                }

                /* --- NEW BULK SEND BUTTON --- */
                .btn-bulk-send {
                    display: flex;
                    align-items: center;
                    background: linear-gradient(135deg, #2563eb, #1d4ed8);
                    color: white;
                    border: none;
                    padding: 12px 20px;
                    border-radius: 12px;
                    font-size: 14px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
                    white-space: nowrap;
                }
                .btn-bulk-send:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 16px rgba(37, 99, 235, 0.3);
                }

                /* --- NEW ADD MEMBER BUTTON --- */
                .btn-add-member {
                    display: flex;
                    align-items: center;
                    background: linear-gradient(135deg, #2563eb, #1d4ed8);
                    color: white;
                    border: none;
                    padding: 12px 20px;
                    border-radius: 12px;
                    font-size: 14px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
                    white-space: nowrap;
                }
                .btn-add-member:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 16px rgba(37, 99, 235, 0.3);
                }

                /* --- COUNT DISPLAY --- */
                .count-display-modern {
                    display: inline-flex;
                    align-items: center;
                    background: #eff6ff;
                    padding: 8px 16px;
                    border-radius: 12px;
                    border: 1px solid #bfdbfe;
                    box-shadow: 0 2px 4px rgba(37, 99, 235, 0.05);
                    gap: 8px;
                }
                .count-label {
                    color: #1e40af;
                    font-weight: 600;
                    font-size: 15px;
                }
                .count-number {
                    background: transparent;
                    color: #1d4ed8;
                    font-weight: 800;
                    font-size: 16px;
                }

                /* --- LOADER --- */
                .loader-wrapper { display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 50vh; width: 100%; }
                .spinner { width: 40px; height: 40px; border: 4px solid #E5E7EB; border-top: 4px solid #2563EB; border-radius: 50%; animation: spin 1s linear infinite; margin-bottom: 12px; }
                @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }

                /* ANIMATION */
                @keyframes slideInUp { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }
                .slide-up-element { opacity: 0; animation: slideInUp 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards; }

                @media (max-width: 640px) {
                    .filter-container-modern { 
                        flex-direction: column;
                        align-items: stretch;
                    }
                    .search-wrapper-modern { 
                        max-width: 100%; 
                    }
                    .btn-bulk-send, .btn-add-member {
                        justify-content: center;
                    }
                    .count-display-modern {
                        margin-left: 0;
                        justify-content: center;
                    }
                }
            `}</style>
        </div>
    );
};

// Updated ActionButton to accept onClick props
const ActionButton = ({ icon, color, label, link, onClick }) => {
    if (onClick) {
        return (
            <button onClick={onClick} className="action-btn-wrapper" style={{ textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
                <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
                <span className="btn-label">{label}</span>
            </button>
        );
    }

    return (
        <a href={link || "#"} className="action-btn-wrapper" style={{ textDecoration: 'none' }} target="_blank" rel="noreferrer">
            <div className="circle-btn" style={{ backgroundColor: color }}>{icon}</div>
            <span className="btn-label">{label}</span>
        </a>
    );
};

export default MyGroup;